import Onlineclass1 from './Onlineclass1'

export default Onlineclass1